import getColor from 'happytree';

export enum Breakpoint {
  ExtraSmall = 0,
  Small = 480,
  Medium = 768,
  Large = 1024,
}

export const breakpoints = {
  xs: Breakpoint.ExtraSmall,
  sm: Breakpoint.Small,
  md: Breakpoint.Medium,
  lg: Breakpoint.Large,
};

type BoxShadowLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const theme = {
  breakpoints,
  zIndex: {
    backdrop: 1000,
    modal: 1010,
    popper: 1000,
    portal: 1000,
  },
  boxShadow: (opts?: {
    level?: BoxShadowLevel;
    placement?: 'top' | 'bottom' | 'left' | 'right';
  }) => {
    const options = {
      level: 1 as BoxShadowLevel,
      placement: 'bottom',
      ...opts,
    };

    const distances = {
      0: '',
      1: '2px',
      2: '4px',
      3: '8px',
      4: '12px',
      5: '18px',
      6: '20px',
    };

    const getXYPosition = (level: BoxShadowLevel) => {
      if (options.placement === 'bottom') {
        return `0px ${distances[level]}`;
      }
      if (options.placement === 'top') {
        return `0px -${distances[level]}`;
      }
      if (options.placement === 'left') {
        return `${distances[level]} 0px`;
      }
      if (options.placement === 'right') {
        return `-${distances[level]} 0px`;
      }
    };

    // prettier-ignore
    return {
      0: 'none',
      1: `${getXYPosition(1)} 2px rgba(6, 29, 58, 0.05), ${getXYPosition(1)} 10px rgba(6, 29, 58, 0.05)`,
      2: `${getXYPosition(2)} 4px rgba(6,29,58,0.05), ${getXYPosition(2)} 10px rgba(6,29,58,0.1)`,
      3: `${getXYPosition(3)} 8px rgba(6, 29, 58, 0.05), ${getXYPosition(3)} 16px rgba(6, 29, 58, 0.1), ${getXYPosition(3)} 16px rgba(6, 29, 58, 0.15)`,
      4: `${getXYPosition(4)} 12px rgba(6, 29, 58, 0.05), ${getXYPosition(4)} 24px rgba(6, 29, 58, 0.1), ${getXYPosition(4)} 24px rgba(6, 29, 58, 0.15)`,
      5: `${getXYPosition(5)} 18px rgba(6, 29, 58, 0.05), ${getXYPosition(5)} 32px rgba(6, 29, 58, 0.1), ${getXYPosition(5)} 32px rgba(6, 29, 58, 0.15)`,
      6: `${getXYPosition(6)} 20px rgba(6, 29, 58, 0.05), ${getXYPosition(6)} 40px rgba(6, 29, 58, 0.1), ${getXYPosition(6)} 40px rgba(6, 29, 58, 0.15)`,
    }[options.level || 1];
  },
};

export const boxSpacing = [0, 4, 8, 16, 24, 32, 48, 64];

// This value represents the alpha channel in an 8 character hexcode (#RGBA)
// For example red with 0.25 opacity can be written as #F000004A, where the 7th and 8th characters
// represent the alpha channel. This is useful for us because we can add opacity to our generated colors
// without having to convert from hex to rbga.
// example use case: `${getColor('primary')}${HEX_ALPHA_TRANSPARANCY_25}` will return primary blue at 25% opacity

// See the "8 digits" section in  https://drafts.csswg.org/css-color/#hex-notation for more info
export const HEX_ALPHA_TRANSPARANCY_25 = '4A';

export { getColor };
